'use client'

import { useEffect } from 'react'
import { fixTextLinkAriaLabels } from '@/lib/accessibility'

export default function AccessiBeAriaFix() {
	useEffect(() => {
		let frameId = 0

		const scheduleFix = () => {
			cancelAnimationFrame(frameId)
			frameId = requestAnimationFrame(() => {
				fixTextLinkAriaLabels(document.body)
			})
		}

		scheduleFix()

		const timeouts = [500, 1500, 3000, 5000].map((delay) =>
			window.setTimeout(scheduleFix, delay),
		)

		const observer = new MutationObserver(scheduleFix)
		observer.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['aria-label', 'data-custom-button-processed'],
		})

		return () => {
			cancelAnimationFrame(frameId)
			timeouts.forEach((timeoutId) => window.clearTimeout(timeoutId))
			observer.disconnect()
		}
	}, [])

	return null
}
